import { handleAvailable, handleRequest, handleUnavailable } from '../reducerHandlers';
import { LocalStorageService } from '../services/localStorage';
import { createReducer } from './utils';

import {
    SERVICES_FAILURE,
    SERVICES_LOADING,
    SERVICES_SUCCESS,
    SNACK_SET,
} from './constants';

const defaultState = {
    isServicesErrorRatesLoading: false,
    servicesErrorRates: { error_rates: [] },
    isServicesCloudsqlLatencyLoading: false,
    servicesCloudsqlLatency: { cloudsql_latency: [], final_time_measure: 'ms' },
    isServicesLatencyLoading: false,
    servicesLatency: { latency_ms: [], final_time_measure: 'ms' },
};

export const reducer = createReducer(defaultState, {
    [SERVICES_LOADING]: handleRequest,
    [SERVICES_SUCCESS]: handleAvailable,
    [SERVICES_FAILURE]: handleUnavailable,
});

export function getServicesErrorRates(payload = {}) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'servicesErrorRates'
        const loadingName = 'isServicesErrorRatesLoading'
        dispatch({ type: SERVICES_LOADING, payload: { loadingName: loadingName } });
        try {
            const localStorageService = new LocalStorageService();
            const servicesErrorRates = localStorageService.get(localStorageService.paths.services_error_rates);

            let response;
            if (servicesErrorRates) {
                response = JSON.parse(servicesErrorRates);
            } else {
                response = await dataSource.getServicesErrorRates(payload);
                localStorageService.save(localStorageService.paths.services_error_rates, response, { expirationSeconds: 1 });
                response = JSON.parse(response);
            }
            dispatch({
                type: SERVICES_SUCCESS,
                payload: { keyState: keyState, data: response, loadingName: loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: SERVICES_FAILURE,
                payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
            });
            const snack = {
                open: true,
                message: "There was an error getting Services Error Rates.",
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getServicesCloudsqlLatency(payload = {}) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'servicesCloudsqlLatency'
        const loadingName = 'isServicesCloudsqlLatencyLoading'
        dispatch({ type: SERVICES_LOADING, payload: { loadingName: loadingName } });
        try {
            const localStorageService = new LocalStorageService();
            const servicesCloudsqlLatency = localStorageService.get(localStorageService.paths.services_cloudsql_latency);

            let response;
            if (servicesCloudsqlLatency) {
                response = JSON.parse(servicesCloudsqlLatency);
            } else {
                response = await dataSource.getServicesCloudsqlLatency(payload);
                localStorageService.save(localStorageService.paths.services_cloudsql_latency, response, { expirationSeconds: 1 });
                response = JSON.parse(response);
            }
            dispatch({
                type: SERVICES_SUCCESS,
                payload: { keyState: keyState, data: response, loadingName: loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: SERVICES_FAILURE,
                payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
            });
            const snack = {
                open: true,
                message: "There was an error getting Services Cloudsql Latency.",
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getServicesLatency(payload = {}) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'servicesLatency'
        const loadingName = 'isServicesLatencyLoading'
        dispatch({ type: SERVICES_LOADING, payload: { loadingName: loadingName } });
        try {
            const localStorageService = new LocalStorageService();
            const servicesLatency = localStorageService.get(localStorageService.paths.services_latency);

            let response;
            if (servicesLatency) {
                response = JSON.parse(servicesLatency);
            } else {
                response = await dataSource.getServicesLatency(payload);
                localStorageService.save(localStorageService.paths.services_latency, response, { expirationSeconds: 1 });
                response = JSON.parse(response);
            }
            dispatch({
                type: SERVICES_SUCCESS,
                payload: { keyState: keyState, data: response, loadingName: loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: SERVICES_FAILURE,
                payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
            });
            const snack = {
                open: true,
                message: "There was an error getting Services Latency.",
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getCloudProjects() {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'cloudProjects'
        const loadingName = 'isCloudProjectsLoading'
        dispatch({ type: SERVICES_LOADING, payload: { loadingName: loadingName } });
        try {
            const localStorageService = new LocalStorageService();
            const cloudProjects = localStorageService.get(localStorageService.paths.cloud_projects);

            let response;
            if (cloudProjects) {
                response = JSON.parse(cloudProjects);
            } else {
                response = await dataSource.getCloudProjects();
                localStorageService.save(localStorageService.paths.cloud_projects, response, { expirationSeconds: 1 });
                response = JSON.parse(response);
            }
            dispatch({
                type: SERVICES_SUCCESS,
                payload: { keyState: keyState, data: response, loadingName: loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: SERVICES_FAILURE,
                payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
            });
            const snack = {
                open: true,
                message: "There was an error getting Cloud Projects.",
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getServicesRequestCount(payload = {}) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'servicesRequestCount'
        const loadingName = 'isServicesRequestCountLoading'
        dispatch({ type: SERVICES_LOADING, payload: { loadingName: loadingName } });
        try {
            const localStorageService = new LocalStorageService();
            const servicesRequestCount = localStorageService.get(localStorageService.paths.services_request_count);

            let response;
            if (servicesRequestCount) {
                response = JSON.parse(servicesRequestCount);
            } else {
                response = await dataSource.getServicesRequestCount(payload);
                localStorageService.save(localStorageService.paths.services_request_count, response, { expirationSeconds: 1 });
                response = JSON.parse(response);
            }
            dispatch({
                type: SERVICES_SUCCESS,
                payload: { keyState: keyState, data: response, loadingName: loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: SERVICES_FAILURE,
                payload: { keyState: keyState, loadingName: loadingName, defaultState: [] },
            });
            const snack = {
                open: true,
                message: "There was an error getting Services Request Count.",
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    }
}